<template>
  <div
    v-fade-on-scroll="$_onScroll"
    class="global-bottom-button"
    :class="{ 'global-bottom-button--active': (scrolled || $route.name === 'article') && $route.name !== 'menu' }"
    @click="$router.push({ name: 'info-contacts' })"></div>
</template>

<script>
export default {
  data: () => ({
    scrolled: window.pageYOffset >= window.innerHeight
  }),
  methods: {
    $_onScroll () {
      this.scrolled = window.pageYOffset > window.innerHeight
    }
  },
  directives: {
    'fade-on-scroll': {
      bind (el, binding) {
        window.addEventListener('scroll', binding.value)
      },
      unbind (el, binding) {
        window.removeEventListener('scroll', binding.value)
      }
    }
  }
}
</script>

<style lang="scss">

@import '../assets/scss/breakpoint.scss';

.global-bottom-button {
  position: fixed;
  transition: opacity .3s;
  opacity: 0;
  visibility: hidden;
  right: 0;
  bottom: 0;
  margin: 6.25%;
  background-color: white;
  background-image: url('./../assets/img/contact-ico.svg');
  background-size: 20px auto;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  z-index: 120;
  box-shadow: 2px 2px 10px rgba(0,0,0,.3);
  cursor: pointer;
  @include media(">=large"){
    margin: 3.25%;
  bottom: 120px;
  }
}

.global-bottom-button--active {
  opacity: 1;
  visibility: visible;
}
</style>
